import { useEffect, useState } from "react";
import { Card } from "react-bootstrap";

const StockCardLayout = ({ inventoryCount, filterAction = null, inventoryType }) => {
  const [selectedId, setSelectedId] = useState(null);
  const cards = inventoryCount;
  const cardWidth = `${100 / (cards?.length ?? 0)}%`;
  const widths = cards.length < 8 ? { flexBasis: cardWidth, maxWidth: cardWidth } : {};

  useEffect(() => {
      let selected = null
      if(inventoryType) selected = inventoryType;
      setSelectedId(inventoryType);
  }, [inventoryType])

  return (
    <div className="my-2 stock-card-container">
      <div className="less-than-8 row m-0 p-0 d-flex justify-content-start align-items-center flex-wrap">
        {cards.map((card, index) => (
          <div className="custom-col m-0 p-0" style={{ cursor: "pointer", ...widths }} key={index}>
            <Card key={index} className={`w-100 text-start flex-shrink-0 ${selectedId?.id === card.id ? "active bg-app-primary" : ""} py-2`} onClick={() => {
                if(filterAction){
                  filterAction(selectedId?.id === card.id ? null : card);
                  setSelectedId(selectedId?.id === card.id ? null : card);
                }
              }}>
              <Card.Body className="p-2">
                <Card.Title>{card?.name ?? ""}</Card.Title>
                <h4>{card?.count ?? 0}</h4>
              </Card.Body>
            </Card>
          </div>
        ))}
      </div>

      {/* {selectedId ? <div className="p-2 info-section bg-app-primary text-center d-flex justify-content-around align-items-center flex-wrap"> {Object.keys(selectedId).map((item, index) => {
        return <div className="info-item" key={index}>
          <span className="me-2"><FaCircle size={"8px"} className="me-2" /> {item}</span>
          <strong>{selectedId[item]}</strong>
        </div>
      })}</div> : null} */}
    </div>
  );
}

export default StockCardLayout;